import clsx from 'clsx'

import { Breadcrumb } from './Breadcrumb'

interface BreadcrumbsProps {
  activeBreadcrumbIndex: number
  breadcrumbs: {
    label: string
    value: string
  }[]
  className?: string
  setActiveBreadcrumb: (value: string) => void
}

export function Breadcrumbs({
  className = '',
  activeBreadcrumbIndex,
  breadcrumbs,
  setActiveBreadcrumb,
}: BreadcrumbsProps) {
  return (
    <ul className="sticky mt-8 flex h-screen flex-col justify-between">
      <div className={`flex w-full flex-col justify-center ${className}`}>
        {breadcrumbs.map(({ label, value }, i) => {
          const isActive = activeBreadcrumbIndex === i
          /* Still need to address this.  Probably needs to be an upstream handling in the breadcrumb array. */
          const isComplete = false

          return (
            <li
              className={clsx('flex items-center py-4', isActive ? 'text-on-media' : 'text-tertiary')}
              key={i}
              onClick={() => setActiveBreadcrumb(value)}
              role="presentation"
            >
              <Breadcrumb index={i} isActive={isActive} isComplete={isComplete} label={label} />
            </li>
          )
        })}
      </div>
    </ul>
  )
}
